import { render, staticRenderFns } from "./anaInfos-second.vue?vue&type=template&id=5b4bac55&scoped=true"
import script from "./anaInfos-second.vue?vue&type=script&lang=js"
export * from "./anaInfos-second.vue?vue&type=script&lang=js"
import style0 from "./anaInfos-second.vue?vue&type=style&index=0&id=5b4bac55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4bac55",
  null
  
)

export default component.exports